import React, { useMemo } from "react";
import useResources from "../../hooks/useResources";

export const findVendor = (vendors, vendor_id) => {
  const foundVendor = (vendors || []).find((vendor) => vendor.id === vendor_id);

  return foundVendor ? foundVendor.name : `No vendor ${vendor_id}`;
};

const VendorCell = ({ data }) => {
  const { vendors } = useResources();

  const vendor_id = useMemo(() => {
    if (
      data &&
      data.data &&
      (data.data.vendor_id || data.data.vendor_invoice_id)
    )
      return data.data.vendor_id || data.data.vendor_invoice_id;
  }, [data]);

  return (
    <div style={{ textAlign: "left" }}>{findVendor(vendors, vendor_id)}</div>
  );
};

export default VendorCell;
